<template>
  <div>
    <v-toolbar class="toolbar-element" light absolute flat height="90em">
      <v-toolbar-title class="toolbar-title" >Presupuestos</v-toolbar-title>
    </v-toolbar>
    <div class="spacing-top custom-font-regular">
      <v-layout row wrap>
        <v-flex xs6 v-if="$store.getters.isSafRole">
          <v-flex xs11>
            <v-subheader class="pl-1">Seleccione el club:</v-subheader>
          </v-flex>
          <v-flex xs11>
            <v-autocomplete v-model="selectedClub" :items="clubs" label="Club" itemText="nombre" itemValue="pk"
                      solo light no-data-text="No hay datos disponibles"></v-autocomplete>
          </v-flex>
        </v-flex>
        <v-flex xs6>
          <v-flex xs11>
            <v-subheader class="pl-1">Seleccione la temporada:</v-subheader>
          </v-flex>
          <v-flex xs11>
            <v-select v-model="selectedSeason" :items="seasons" label="Temporada" itemText="nombre" itemValue="pk"
                      solo light no-data-text="No hay datos disponibles"></v-select>
          </v-flex>
        </v-flex>
      </v-layout>
      <v-tabs v-model="active" color="#293968" v-if="budget">
        <v-tab v-for="n in items.length" :key="n" ripple>
          <span class="white--text">{{ items[n-1].text }}</span>
        </v-tab>
        <v-tab-item v-for="n in items.length" :key="n">
          <v-card flat>
            <PresupuestoTable :idTable="budget.tables[items[n-1].firstTable]" :title="items[n-1].text"
                              :idSecondTable="budget.tables[items[n-1].secondTable]"></PresupuestoTable>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </div>
  </div>
</template>

<script>
import PresupuestoTable from './PresupuestoTable'

export default {
  components: {
    PresupuestoTable
  },

  data () {
    return {
      active: 0,
      selectedClub: null,
      selectedSeason: null,
      clubs: [],
      seasons: [],
      budget: null,
      items: [
        { text: 'Económico', firstTable: 'recursos', secondTable: 'gastos' },
        { text: 'Financiero', firstTable: 'ingresos', secondTable: 'egresos' },
        { text: 'Inversiones', firstTable: 'inversiones' }]
    }
  },

  methods: {
    fetchClubs () {
      this.axios
        .get('budget/clubs')
        .then(response => { this.clubs = response.data })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    fetchSeason () {
      this.axios
        .get('seasons')
        .then(response => { this.seasons = response.data })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    fetchBudget () {
      this.axios
        .get(`/budget/${this.selectedSeason}` + ((this.$store.getters.isSafRole) ? `/${this.selectedClub}` : ''))
        .then(response => { this.budget = response.data })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    fetchData () {
      if (this.$store.getters.isSafRole) {
        this.fetchClubs()
      }
      this.fetchSeason()
    }
  },

  mounted () {
    this.fetchData()
  },

  watch: {
    'selectedClub' () {
      this.budget = null
      if (this.selectedSeason) {
        this.fetchBudget()
      }
    },
    'selectedSeason' () {
      this.budget = null
      if (this.selectedClub || this.$store.getters.isClubRole) {
        this.fetchBudget()
      }
    },
    '$store.getters.isSafRole' () {
      this.fetchClubs()
    }
  }
}
</script>

<style scoped>
.toolbar-element {
  background: linear-gradient(#e2e2e2, #cbd1db);
}
.toolbar-title {
  font-size: 2.2em;
  font-family: SourceSansProLight, sans-serif;
  color: #293968;
}
.spacing-top {
  margin-top: 5.2em !important;
}
</style>
